import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fontSizeZoomLevel',
    standalone: false
})
export class FontSizeZoomLevelPipe implements PipeTransform {

  transform(zoomLevel: number): number {
    if (zoomLevel === 0) {
      zoomLevel += 1;
    }
    let divider = 4;
    if (zoomLevel > 9) {
      divider = 5;
    }

    return 8 + ( zoomLevel / divider );
  }
}
